import { render, staticRenderFns } from "./printSalvage.vue?vue&type=template&id=fc6632e2&scoped=true"
import script from "./printSalvage.vue?vue&type=script&lang=js"
export * from "./printSalvage.vue?vue&type=script&lang=js"
import style0 from "./printSalvage.vue?vue&type=style&index=0&id=fc6632e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc6632e2",
  null
  
)

export default component.exports